import cx from 'classnames';
import React from 'react';

import styles from './styles.module.css';

const bone = (extra) => cx(styles.bone, extra);

const SIDEBAR_GROUPS = [
	{
		label: 'Today',
		items: [
			['86%', '72%'],
			['74%', '60%'],
		],
	},
	{
		label: 'Yesterday',
		items: [
			['80%', '68%'],
			['70%', '55%'],
		],
	},
	{ label: 'This week', items: [['78%', '64%']] },
];

const HINT_WIDTHS = [72, 60, 56, 68, 80];

const BotMessage = ({ lines, withCard }) => (
	<div className={styles.msgRow}>
		<div className={bone(styles.avatarBone)} />
		<div className={styles.bubbleWrap}>
			<div className={bone(styles.senderBone)} />
			{lines.map((w) => (
				<div key={w} className={bone(styles.bubbleLine)} style={{ width: w }} />
			))}
			{withCard && <div className={bone(styles.cardBone)} />}
		</div>
	</div>
);

const UserMessage = ({ lines }) => (
	<div className={cx(styles.msgRow, styles.msgRowUser)}>
		<div className={bone(styles.avatarBone)} />
		<div className={styles.bubbleWrap}>
			<div className={bone(styles.senderBone)} />
			{lines.map((w) => (
				<div key={w} className={bone(styles.bubbleLine)} style={{ width: w }} />
			))}
		</div>
	</div>
);

const AssistantSkeleton = () => (
	<div className={styles.layout}>
		<aside className={styles.sidebar}>
			<div className={styles.sidebarHeader}>
				<div className={bone(styles.sidebarLabelBone)} />
				<div className={bone(styles.newChatBone)} />
			</div>
			<div className={styles.historyList}>
				{SIDEBAR_GROUPS.map((group) => (
					<React.Fragment key={group.label}>
						<div className={bone(styles.groupLabelBone)} />
						{group.items.map(([titleW, previewW]) => (
							<div key={titleW} className={styles.historyItem}>
								<div className={bone(styles.itemTitleBone)} style={{ width: titleW }} />
								<div className={bone(styles.itemPreviewBone)} style={{ width: previewW }} />
								<div className={bone(styles.itemTimeBone)} />
							</div>
						))}
					</React.Fragment>
				))}
			</div>
		</aside>

		<main className={styles.main}>
			<div className={styles.topBar}>
				<div className={bone(styles.topBarIconBone)} />
				<div className={styles.topBarTextWrap}>
					<div className={bone(styles.topBarTitleBone)} />
					<div className={bone(styles.topBarSubBone)} />
				</div>
				<div className={bone(styles.topBarActionBone)} />
			</div>

			<div className={styles.messages}>
				<UserMessage lines={['220px']} />
				<BotMessage lines={['280px', '180px']} withCard />
				<UserMessage lines={['160px']} />
				<BotMessage lines={['320px']} />
			</div>

			<div className={styles.inputArea}>
				<div className={bone(styles.inputBone)} />
				<div className={styles.hintRow}>
					{HINT_WIDTHS.map((w) => (
						<div key={w.toString()} className={bone(styles.hintBone)} style={{ width: w }} />
					))}
				</div>
			</div>
		</main>
	</div>
);

export default AssistantSkeleton;
